import MUIDataTable from 'mui-datatables';
import React, { Component } from 'react'
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
// 
import { userid } from '../../Common/Credentials.js';
import { spin } from '../../Common/NewLoader.jsx';
import CustomToolbar from '../../CommonComponents/CustomToolbar.js';
import Header from '../../Component/Header.js';
import Menu from '../../Component/Menu.js';
import { ThemeProvider, Tooltip } from "@mui/material";
import { createTheme } from "@mui/material";
import MasterService from '../MasterService.js';
import deleteIcon from "../../images/Icons/delete.png";
import Breadcrumb from '../../NewUI/NewComponents/Breadcrumb.jsx';



const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, 'solid', '#ece6e6']],
      },
      body:
      {
        border: [[1, 'solid', '#ece6e6']],
      },
    },
  },
});


class CitiesTable extends Component {


  constructor(props) {
    super(props)

    this.state = {
      message: '',
      citiesdata: [],
      loading: false,

    }
    // this.refreshCustomer=this.refreshCustomer.bind(this)
    // this.deleteColour=this.deleteColour.bind(this)
  }


  deleteCity(id) {
    MasterService.DeleteCity(id)
      .then(() =>
        MasterService.getAllCities()
          .then(response =>
            this.setState({ citiesdata: response.data }),
            this.setState({ message: "Citiy Deleted Successfully" })
          )
      )
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })

  }


  componentDidMount() {

    if (userid === undefined) {
      window.confirm('Your Session is Lost: Please login Back to resume')
      this.props.navigate(`/`)
    }

    this.setState({ loading: true })
    MasterService.getAllCities().then(res => this.setState({ citiesdata: res.data, loading: false }))
  }

  render() {

    const columns = [
      { name: "id", label: "Id", options: { filter: false, sort: true, display: false } },
      { name: "name", label: "City", options: { filter: false, sort: true, } },
      { name: "state", label: "State", options: { filter: true, sort: true, } },
      { name: "country", label: "Country", options: { filter: true, sort: true, } },
      {
        name: "Delete",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {

            return (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you wish to delete Colour ${tableMeta.rowData.find((e) => e)}?`
                    )
                  )
                    this.deleteCity(tableMeta.rowData.find((e) => e));
                }}
              >
                <Tooltip title="Delete">
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    style={{ width: "1.3rem", height: "1.3rem" }}
                  />
                </Tooltip>
              </span>
            );

          },
        },
      },
    ];
    const options = {
      filterType: 'checkbox',
      selectableRows: "none",
      customToolbar: () => {
        return (<>

          <Link as="button" className="float-right btn btn-sm m-0 p-0" to={{ pathname: "/addcity" }}>
            <CustomToolbar />
          </Link>
        </>
        );
      }
    }
    return (
      <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
      <div className="UI-container">
        <div className='UI-card'>
      <div className={`UI-header`}>
        <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"Cities",path:null}]}/>
      </div>
          <div className="UI-table-container">
                      {this.state.loading === true ? <div className="text-center">{spin}</div> :
                        <ThemeProvider theme={theme}>
                          <MUIDataTable
                            className="table-sm"
                            title={"Cities"}
                            data={this.state.citiesdata}
                            columns={columns}
                            options={options}
                          />
                        </ThemeProvider>
                      }
                    </div>
                  </div>
          </div>
        </div>
      </div>

    )

  }

}
export default withRouter(CitiesTable)